<app-loss-latency-bar [kpiType]="kpiType"></app-loss-latency-bar>